// Import Vue
import Vue from 'vue'
import VueRouter from 'vue-router'

import MapContact from '@/mapcontact/MapContact.vue'
import {testappUse } from 'TESTAPP/testapp.js'

function start_eto_mapcontact( el ) {
    new Vue({
        el,
        render: h => h(MapContact),
    })
}


export {start_eto_mapcontact}


if (testappUse) {
    window._dev_start_eto_mapcontact = start_eto_mapcontact
}
